module.exports = require("./fr-RW.d.ts");